/**
 * Created by pierremarsot on 24/07/2017.
 */
import {
    LOGIN_ERROR,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_ERROR,
} from '../actions/auth';
import {getToken, TYPE_COMPTE, getLocalStorage} from '../tools/localStorage';

const initialState = {
    token: getToken(),
    type_compte: getLocalStorage(TYPE_COMPTE)
};

export default function auth(state = initialState, action = {}) {
    switch (action.type) {
        case LOGOUT_ERROR:
        case LOGIN_ERROR:
            return state;

        case LOGIN_SUCCESS:
            if (!action.token || action.token.length === 0 || !action.type_compte || action.type_compte.length === 0) {
                return {
                    ...state,
                    token: '',
                    type_compte: '',
                };
            }

            return {
                ...state,
                token: action.token,
                type_compte: action.type_compte,
            };

        case LOGOUT_SUCCESS:
            return {
                ...state,
                token: '',
                type_compte: '',
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js